import React, {useContext, useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {TextField} from '@material-ui/core';
import {fromEvent} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import {I18nContext} from 'contexts/i18n';

const FilterInput = ({placeholder, onChange, searchDebounceTime, ...restProps}) => {
  const {i18nTranslate} = useContext(I18nContext);
  const [value, setValue] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    const subscription = fromEvent(inputRef.current, 'keyup')
      .pipe(debounceTime(searchDebounceTime))
      .subscribe(({target: {value}}) => onChange(value));
    return () => {
      subscription.unsubscribe();
    };
  }, []);

  return (
    <TextField
      ref={inputRef}
      placeholder={placeholder || i18nTranslate`Search`}
      margin="dense"
      value={value}
      onChange={({target: {value}}) => setValue(value)}
      {...restProps}
    />
  );
};

FilterInput.propTypes = {
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  searchDebounceTime: PropTypes.number.isRequired,
  style: PropTypes.object.isRequired,
};

FilterInput.defaultProps = {
  searchDebounceTime: 400,
  style: {},
};

export default FilterInput;
